import {ReferenceIdSchema} from '@cohort/shared/schema/common/referenceId';
import {z} from 'zod';

export const ReferenceIdFormSchema = z
  .string()
  .refine(value => value === '' || value.trim().length >= 1, {message: 'errorTooShort1'})
  .transform(value => (value === '' ? undefined : value))
  .pipe(ReferenceIdSchema.optional());
